"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Sanitized = function Sanitized(_ref) {
  var html = _ref.html,
      className = _ref.className,
      id = _ref.id,
      style = _ref.style,
      wrapperTag = _ref.wrapperTag,
      options = _ref.options,
      other = _objectWithoutProperties(_ref, ["html", "className", "id", "style", "wrapperTag", "options"]);

  var sanitizedHTML = (0, _sanitizeHtml["default"])(html, options);
  return _react["default"].createElement(wrapperTag, _objectSpread({
    className: className,
    dangerouslySetInnerHTML: {
      __html: sanitizedHTML
    },
    id: id,
    style: style
  }, other));
};

Sanitized.defaultProps = {
  className: null,
  id: null,
  style: null,
  options: null,
  wrapperTag: "span"
};
Sanitized.propTypes = {
  wrapperTag: _propTypes["default"].string,
  html: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string,
  style: _propTypes["default"].objectOf(_propTypes["default"].string),
  options: _propTypes["default"].objectOf(_propTypes["default"].any)
};
var withMemo = _react["default"].memo ? _react["default"].memo(Sanitized) : Sanitized;
var _default = withMemo;
exports["default"] = _default;
//# sourceMappingURL=index.js.map